import { useCallback, useEffect, useState } from 'react';
import '../Analitos.scss';
import Popup from 'devextreme-react/popup';
import { useApiConfiguration } from '../../../api/api.configuration';
import { SysAAnalitosRangosAlternos, SysAAnalitosUnidadesMedida, SysACodigoBarras, SysIAnalitosTipoMuestras } from '../../../types/types.analitos';
import { useScreenSize } from '../../../utils/media-query';
import { SamplesTypes } from '../Components/SamplesTypes';
import { AlternateRanks } from '../Components/AlternateRanks';
import { Barcodes } from '../Components/Barcodes';
import { UnitMeasurements } from '../Components/UnitMeasurements';
import { ModalMicrobiologyCatalogs } from '../Components/ModalMicrobiologyCatalogs';

export const ModalModulesAnalytes = ({ visible, setVisible, Modulo }: { visible: boolean; setVisible: (value: boolean) => void; Modulo: number }) => {
  const { isMedium, isSmall, isXSmall } = useScreenSize();
  const { getListasAnalitos } = useApiConfiguration();
  const [tipoMuestra, setTipoMuestra] = useState<SysIAnalitosTipoMuestras[]>([]);
  const [rangosAlternos, setRangosAlternos] = useState<SysAAnalitosRangosAlternos[]>([]);
  const [unidadesMedida, setUnidadesMedida] = useState<SysAAnalitosUnidadesMedida[]>([]);
  const [codBarras, setCodBarras] = useState<SysACodigoBarras[]>([]);

  useEffect(() => {
    handleUpdateData();
  }, []);

  const handleUpdateData = () => {
    getListasAnalitos().then((res) => {
      setTipoMuestra(res.TiposMuestras);
      setRangosAlternos(res.RangoAlternos);
      setUnidadesMedida(res.UnidadesMedida);
      setCodBarras(res.ConBarras);
    });
    
  };

  const handleVisible = useCallback(() => {
    setVisible(false);
  }, []);

  return (
    <Popup width={1200} height={'90%'} fullScreen={isMedium || isSmall || isXSmall} visible={visible} onHidden={handleVisible} title={Modulo === 1 ? 'TIPOS DE MUESTRAS' : Modulo === 2 ? 'RANGOS ALTERNOS' : Modulo === 3 ? 'ETIQUETAS CÓDIGO DE BARRAS' : Modulo === 4 ? 'UNIDADES DE MEDIDA' : 'MICROBIOLOGÍA'} showTitle={true} showCloseButton={true}>
      {Modulo === 1 && <SamplesTypes dataMuestras={tipoMuestra} update={handleUpdateData} />}
      {Modulo === 2 && <AlternateRanks dataRanks={rangosAlternos} update={handleUpdateData} />}
      {Modulo === 3 && <Barcodes dataBarcodes={codBarras} update={handleUpdateData} />}
      {Modulo === 4 && <UnitMeasurements dataUnidades={unidadesMedida} update={handleUpdateData} />}
      {Modulo === 5 && <ModalMicrobiologyCatalogs initialTab={0} />}
    </Popup>
  );
};
